import React, { useState, useEffect } from 'react';

import PropTypes from 'prop-types';
import aes from 'crypto-js/aes';
import utf8 from 'crypto-js/enc-utf8';
import { isPrivateMode } from '../helpers/utils';
import get from 'lodash/get';

const METERED_STORY_ACCESS_LEVEL = 100;
const PAID_STORY_ACCESS_LEVEL = 999;

const WithAccess = ({ storyAccess, storyId, storyAccessLevel, isSubscriber, children }) => {
  const [state, setState] = useState({
    hasAccess: storyAccessLevel !== 999,
    hasDirectAccess: false, // added to manage direct access state
  });

  useEffect(() => {
    console.log('storyAccessLevel====>>>', storyAccessLevel, typeof storyAccessLevel);
    if (storyAccessLevel !== 999) {
      const subscriberToken = global.localStorage && global.localStorage.getItem('sbsrbrtknbmbgqt');
      const decodedToken =
        subscriberToken && aes.decrypt(subscriberToken, 'BloombergQuint').toString(utf8);
      const hasDirectAccess = storyAccessLevel !== 999 || isSubscriber;
      console.log('hasDirectAccess subpart 1===>>>', hasDirectAccess);

      setState((prevState) => ({
        ...prevState,
        hasAccess: hasDirectAccess,
        hasDirectAccess,
      }));
    }
  }, [storyAccessLevel, isSubscriber]);

  // const checkForAccess = (accessLevel) => {
  //   return (
  //     global.AccessType &&
  //     global.AccessType.isAssetAccessible({ id: storyId, type: 'story' }, accessLevel !== 999)
  //   );
  // };

  // const callPingBack = (storyId, access) => {
  //   if (global.AccessType) {
  //     return global.AccessType.pingbackAssetAccess({ id: storyId, type: 'story' }, access);
  //   }
  // };

  const { hasAccess, access } = state;

  return children({
    hasAccess,
    access,
  });
};

WithAccess.propTypes = {
  storyId: PropTypes.string.isRequired,
  storyAccess: PropTypes.string,
  storyAccessLevel: PropTypes.any,
  isSubscriber: PropTypes.bool,
  children: PropTypes.func.isRequired,
};

WithAccess.defaultProps = {
  storyAccess: 'public',
  storyAccessLevel: null,
};

export default WithAccess;
